import { render } from "./PortalProductAttribution.vue?vue&type=template&id=6ee7011e&scoped=true"
import script from "./PortalProductAttribution.vue?vue&type=script&lang=js"
export * from "./PortalProductAttribution.vue?vue&type=script&lang=js"

import "./PortalProductAttribution.vue?vue&type=style&index=0&id=6ee7011e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee7011e"]])

export default __exports__